import { render, staticRenderFns } from "./list_item.vue?vue&type=template&id=6006df62&"
import script from "./list_item.vue?vue&type=script&lang=js&"
export * from "./list_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6006df62')) {
      api.createRecord('6006df62', component.options)
    } else {
      api.reload('6006df62', component.options)
    }
    module.hot.accept("./list_item.vue?vue&type=template&id=6006df62&", function () {
      api.rerender('6006df62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/list/list_item.vue"
export default component.exports